// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/****** Spreadsheet ********/
/********** Base **********/
/********** Colours **********/
/********** Pages **********/
/********** Modal **********/
/********** Button **********/
/******* Icons ********/
/******* Icons ********/
/******* Media Queries ********/
.importcontainer {
  width: 70%;
  margin-left: 15%;
  margin-right: 15%;
}

.progressbar {
  counter-reset: step;
}

.progressbar li {
  list-style-type: none;
  float: left;
  width: 33.33%;
  position: relative;
  text-align: center;
}

.progressbar li:before {
  content: counter(step);
  counter-increment: step;
  width: 60px;
  height: 60px;
  line-height: 60px;
  border: 1px solid #ddd;
  display: block;
  text-align: center;
  margin: 0 auto 15px auto;
  border-radius: 50%;
  background-color: white;
}

.progressbar li:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 30px;
  background-color: #ddd;
  top: 10px;
  left: -50%;
  z-index: -1;
}

.progressbar li:first-child:after {
  content: none;
}

.progressbar li.active {
  color: #2b495e;
}

.progressbar li.active:before {
  border-color: #2b495e;
}

.progressbar li.active + li.after {
  background-color: #2b495e;
}

.complete {
  background-color: lightgreen;
  color: black;
  border-color: lightgreen;
}

.softComplete {
  background-color: MOCCASIN;
  color: BLACK;
  border-color: MOCCASIN;
}

.fail {
  background-color: pink;
  color: black;
  border-color: pink;
}

.header {
  padding: 0.5rem 0 0.4rem 0;
  text-align: center;
}

.errors {
  cursor: pointer;
}

.errorField {
  border: 1px solid #ddd;
  margin-left: 15%;
  margin-right: 15%;
  width: 70%;
  height: 30vh;
  margin-top: 1%;
  overflow-y: scroll !important;
  background-color: #999;
}

.spinner {
  margin: 100px auto 0;
  width: 70px;
  text-align: center;
}

.spinner > div {
  width: 18px;
  height: 18px;
  background-color: #2b495e;
  border-radius: 100%;
  display: inline-block;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  animation-delay: -0.16s;
}
@keyframes sk-bouncedelay {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
.message {
  display: none;
  color: PINK;
  background: #999;
  position: absolute;
  top: 10px;
}

.anchor:hover + .message {
  display: block !important;
  z-index: 10;
}

.icon_complete {
  color: light-green;
}

.btn_icon {
  color: #ff9d00;
}

.icon_complete:before {
  content: "\\f00c";
}

span.info {
  border: 1px solid black;
  vertical-align: top;
  padding: 1.1rem;
}

.importer_dialog_container {
  width: 100%;
}

.center_section {
  width: 100%;
  text-align: center;
  display: grid;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  grid-template-rows: 1fr;
  gap: 0.5rem;
  margin-top: 0.5rem;
  margin: 0.5rem auto;
  justify-content: center;
  height: -moz-fit-content;
  height: fit-content;
}

table.data th {
  text-align: center;
}

table.data td {
  text-align: left;
}

.dialog_content_upper {
  padding: 1rem;
  display: grid;
  grid-template-rows: 2rem auto;
}
.dialog_content_upper.no_padding {
  padding: 0;
}
@media (max-width: 767px) {
  .dialog_content_upper {
    padding: 1rem 1rem 1rem;
  }
}
.dialog_content_upper:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
  visibility: hidden;
}
.dialog_content_upper button {
  margin-left: 1.5rem;
}

.container_importer {
  display: grid;
  width: 100%;
  overflow: auto;
}

.aggregation-date-text {
  font-size: smaller;
}

.dataset-error-link {
  cursor: pointer;
}

.error-window-container {
  position: fixed;
  right: 100%;
  top: 0%;
  z-index: 99;
}

kendo-window {
  border-radius: 4px !important;
}

:host ::ng-deep kendo-window-titlebar,
:host ::ng-deep .k-dialog-titlebar,
:host ::ng-deep .k-window-titlebar {
  background-color: #51738b !important;
  padding: 0.25rem 0.5rem !important;
}

.import_error_warning {
  color: #ff9d00;
}

.import_error_error {
  color: #ea5441;
}`, "",{"version":3,"sources":["webpack://./src/app/styles/base/_variables.scss","webpack://./src/app/components/simulation/import-alm-dataset/import-alm-dataset.component.scss"],"names":[],"mappings":"AAEA,4BAAA;AAOA,2BAAA;AAkBA,8BAAA;AAgDA,4BAAA;AAEA,4BAAA;AAGA,6BAAA;AAWA,uBAAA;AAgBA,uBAAA;AAEA,+BAAA;AC3GA;EACE,UAAA;EACA,gBAAA;EACA,iBAAA;AAQF;;AALA;EACE,mBAAA;AAQF;;AALA;EACE,qBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AAQF;;AALA;EACE,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;AAQF;;AANA;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AASF;;AAPA;EACE,aAAA;AAUF;;AARA;EACE,cAAA;AAWF;;AATA;EACE,qBAAA;AAYF;;AAVA;EACE,yBAAA;AAaF;;AAVA;EACE,4BAAA;EACA,YAAA;EACA,wBAAA;AAaF;;AAVA;EACE,0BAAA;EACA,YAAA;EACA,sBAAA;AAaF;;AAVA;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;AAaF;;AAVA;EACE,0BAAA;EACA,kBAAA;AAaF;;AAVA;EACE,eAAA;AAaF;;AAXA;EACE,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,6BAAA;EACA,sBAAA;AAcF;;AAXA;EACE,oBAAA;EACA,WAAA;EACA,kBAAA;AAcF;;AAXA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EAEA,mBAAA;EACA,qBAAA;EAEA,wDAAA;AAaF;;AAVA;EAEE,uBAAA;AAaF;;AAVA;EAEE,uBAAA;AAaF;AACA;EACE;IAIE,mBAAA;EAQF;EANA;IAEE,mBAAA;EAQF;AACF;AALA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;AAOF;;AAJA;EACE,yBAAA;EACA,WAAA;AAOF;;AAJA;EACE,kBAAA;AAOF;;AAJA;EACE,cAAA;AAOF;;AAJA;EACE,gBAAA;AAOF;;AAJA;EACE,uBAAA;EACA,mBAAA;EACA,eAAA;AAOF;;AAJA;EACE,WAAA;AAOF;;AAJA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EAAA,mBAAA;AAOF;;AAJA;EACE,kBAAA;AAOF;;AAJA;EACE,gBAAA;AAOF;;AAJA;EACE,aAAA;EACA,aAAA;EACA,6BAAA;AAOF;AALE;EACE,UAAA;AAOJ;AAJE;EATF;IAUI,uBAAA;EAOF;AACF;AALE;EACE,WAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,kBAAA;AAOJ;AAJE;EACE,mBAAA;AAMJ;;AAFA;EACE,aAAA;EACA,WAAA;EACA,cAAA;AAKF;;AAFA;EACE,kBAAA;AAKF;;AAFA;EACE,eAAA;AAKF;;AAFA;EACE,eAAA;EACA,WAAA;EACA,OAAA;EACA,WAAA;AAKF;;AAFA;EACE,6BAAA;AAKF;;AAFA;;;EAGE,oCAAA;EACA,kCAAA;AAKF;;AAFA;EACE,cD9La;ACmMf;;AAFA;EACE,cDvNI;AC4NN","sourcesContent":["// @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,300i,400,400i,600,600i,700,700i');\r\n\r\n/****** Spreadsheet ********/\r\n\r\n// $spread-sheet-height: 67vh;\r\n$spread-sheet-height: 100%;\r\n$padding: 0.7rem;\r\n$tree-width: 18rem;\r\n\r\n/********** Base **********/\r\n\r\n$base_color: #505050;\r\n$body_background: #ffffff;\r\n$font_pack: 'Source Sans Pro', Helvetica, sans-serif;\r\n$font_size: 0.86rem;\r\n$btn_font_size: 0.76rem;\r\n$app_color: $base_color;\r\n$border_color: #dfe0e1;\r\n$placeholder-color: rgba(#000000, 0.4);\r\n$placeholder-color-white: #ffffff;\r\n$input_background: #ffffff;\r\n$input_background_readonly: #eef0f1; //#EEF0F1\r\n$input_border: #ababab;\r\n$input_border_focus: #505050;\r\n$input_border_expected: #ffcd40;\r\n$input_required: rgba(#f8e71c, 0.3);\r\n\r\n/********** Colours **********/\r\n\r\n$primary_color: #72bf44;\r\n\r\n$black: #000000;\r\n$white: #ffffff;\r\n\r\n$grey_1: #4a4a4a;\r\n$grey_2: #585d69;\r\n$grey_3: #5d6978;\r\n\r\n$lighter_grey: #f5f6f7;\r\n$light_grey: #eceef3;\r\n$grey: #cccccc;\r\n$mid_grey: #7e8c99;\r\n$dark_grey: #525b6b;\r\n$darker_grey: #464c59;\r\n\r\n$disabled_grey: #ababab;\r\n$blue: #51738b; //#04BBEE\r\n$navy: #2b495e;\r\n\r\n$red: #ea5441;\r\n$green: #72bf44;\r\n$orange: #f07d23;\r\n$yellow: #ffcd40;\r\n\r\n$state_hover: rgba($blue, 0.1);\r\n\r\n$shadow_1: rgba($grey_1, 0.2);\r\n$shadow_2: rgba($black, 0.2);\r\n\r\n$row_hover: #f4f6f7;\r\n\r\n$group_color_1: #a7c5e5;\r\n$group_color_2: #d39fe9;\r\n$group_color_3: #e9e19f;\r\n$group_color_4: #9a75ff;\r\n$group_color_5: #a7e5b4;\r\n$group_color_6: #adb1c7;\r\n$group_color_7: #fa8d8d;\r\n$group_color_8: #ffc375;\r\n\r\n$notification: #ff9d00;\r\n$notification_light: rgba($notification, 0.25);\r\n\r\n$tree_btn_hover: #f4f6f7;\r\n\r\n/********** Pages **********/\r\n\r\n/********** Modal **********/\r\n$modal_background: #ffffff;\r\n\r\n/********** Button **********/\r\n$btn_primary_bg: #72bf44;\r\n$btn_primary_bg_hover: darken($btn_primary_bg, 10%);\r\n$btn_primary_color: #ffffff;\r\n$btn_primary_color_hover: #ffffff;\r\n\r\n$btn_secondary_bg: #51738b;\r\n$btn_secondary_bg_hover: darken($btn_secondary_bg, 10%);\r\n$btn_secondary_color: #ffffff;\r\n$btn_secondary_color_hover: #ffffff;\r\n\r\n/******* Icons ********/\r\n\r\n$empyrean_logo: '\\e905';\r\n$sheet_loader: '\\e90d';\r\n$triangle_right: '\\e910';\r\n$valid: '\\e922';\r\n$warning: '\\e923';\r\n$error: '\\e91f';\r\n$chevron_left: '\\e901';\r\n$chevron_right: '\\e902';\r\n$chevron_up: '\\e903';\r\n$chevron_down: '\\e900';\r\n\r\n$x: -50%;\r\n$y: -50%;\r\n\r\n/******* Icons ********/\r\n\r\n/******* Media Queries ********/\r\n\r\n$mobile: '(min-width: 0px) and (max-width: 767px)';\r\n$mobile_portrait: '(min-width: 0px) and (max-width: 767px) and (orientation: portrait)';\r\n$mobile_landscape: '(min-width: 320px) and (max-width: 767px) and (orientation: landscape)';\r\n\r\n$tablet: '(min-width: 768px) and (max-width: 1024px)';\r\n$tablet_portrait: '(min-width: 768px) and (max-width: 1023px) and (orientation: portrait)';\r\n$tablet_landscape: '(min-width: 1024px) and (max-width: 1279px)';\r\n\r\n$desktop: '(min-width: 1025px) and (max-width: 1439px)';\r\n$desktop_wide: '(min-width: 1440px)';\r\n$desktop_extra_wide: '(min-width: 1680px)';\r\n$min_desktop_wide: '(min-width: 1280px)';\r\n\r\n$max_height: '(max-height: 760px)';\r\n","@import '../../../styles/base/variables';\r\n\r\n.importcontainer {\r\n  width: 70%;\r\n  margin-left: 15%;\r\n  margin-right: 15%;\r\n}\r\n\r\n.progressbar {\r\n  counter-reset: step;\r\n}\r\n\r\n.progressbar li {\r\n  list-style-type: none;\r\n  float: left;\r\n  width: 33.33%;\r\n  position: relative;\r\n  text-align: center;\r\n}\r\n\r\n.progressbar li:before {\r\n  content: counter(step);\r\n  counter-increment: step;\r\n  width: 60px;\r\n  height: 60px;\r\n  line-height: 60px;\r\n  border: 1px solid #ddd;\r\n  display: block;\r\n  text-align: center;\r\n  margin: 0 auto 15px auto;\r\n  border-radius: 50%;\r\n  background-color: white;\r\n}\r\n.progressbar li:after {\r\n  content: '';\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 30px;\r\n  background-color: #ddd;\r\n  top: 10px;\r\n  left: -50%;\r\n  z-index: -1;\r\n}\r\n.progressbar li:first-child:after {\r\n  content: none;\r\n}\r\n.progressbar li.active {\r\n  color: #2b495e;\r\n}\r\n.progressbar li.active:before {\r\n  border-color: #2b495e;\r\n}\r\n.progressbar li.active + li.after {\r\n  background-color: #2b495e;\r\n}\r\n\r\n.complete {\r\n  background-color: lightgreen;\r\n  color: black;\r\n  border-color: lightgreen;\r\n}\r\n\r\n.softComplete {\r\n  background-color: MOCCASIN;\r\n  color: BLACK;\r\n  border-color: MOCCASIN;\r\n}\r\n\r\n.fail {\r\n  background-color: pink;\r\n  color: black;\r\n  border-color: pink;\r\n}\r\n\r\n.header {\r\n  padding: 0.5rem 0 0.4rem 0;\r\n  text-align: center;\r\n}\r\n\r\n.errors {\r\n  cursor: pointer;\r\n}\r\n.errorField {\r\n  border: 1px solid #ddd;\r\n  margin-left: 15%;\r\n  margin-right: 15%;\r\n  width: 70%;\r\n  height: 30vh;\r\n  margin-top: 1%;\r\n  overflow-y: scroll !important;\r\n  background-color: #999;\r\n}\r\n\r\n.spinner {\r\n  margin: 100px auto 0;\r\n  width: 70px;\r\n  text-align: center;\r\n}\r\n\r\n.spinner > div {\r\n  width: 18px;\r\n  height: 18px;\r\n  background-color: #2b495e;\r\n\r\n  border-radius: 100%;\r\n  display: inline-block;\r\n  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;\r\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\r\n}\r\n\r\n.spinner .bounce1 {\r\n  -webkit-animation-delay: -0.32s;\r\n  animation-delay: -0.32s;\r\n}\r\n\r\n.spinner .bounce2 {\r\n  -webkit-animation-delay: -0.16s;\r\n  animation-delay: -0.16s;\r\n}\r\n\r\n@-webkit-keyframes sk-bouncedelay {\r\n  0%,\r\n  80%,\r\n  100% {\r\n    -webkit-transform: scale(0);\r\n  }\r\n  40% {\r\n    -webkit-transform: scale(1);\r\n  }\r\n}\r\n\r\n@keyframes sk-bouncedelay {\r\n  0%,\r\n  80%,\r\n  100% {\r\n    -webkit-transform: scale(0);\r\n    transform: scale(0);\r\n  }\r\n  40% {\r\n    -webkit-transform: scale(1);\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.message {\r\n  display: none;\r\n  color: PINK;\r\n  background: #999;\r\n  position: absolute;\r\n  top: 10px;\r\n}\r\n\r\n.anchor:hover + .message {\r\n  display: block !important;\r\n  z-index: 10;\r\n}\r\n\r\n.icon_complete {\r\n  color: light-green;\r\n}\r\n\r\n.btn_icon {\r\n  color: #ff9d00;\r\n}\r\n\r\n.icon_complete:before {\r\n  content: '\\f00c';\r\n}\r\n\r\nspan.info {\r\n  border: 1px solid black;\r\n  vertical-align: top;\r\n  padding: 1.1rem;\r\n}\r\n\r\n.importer_dialog_container {\r\n  width: 100%;\r\n}\r\n\r\n.center_section {\r\n  width: 100%;\r\n  text-align: center;\r\n  display: grid;\r\n  grid-auto-columns: max-content;\r\n  grid-auto-flow: column;\r\n  grid-template-rows: 1fr;\r\n  gap: 0.5rem;\r\n  margin-top: 0.5rem;\r\n  margin: 0.5rem auto;\r\n  justify-content: center;\r\n  height: fit-content;\r\n}\r\n\r\ntable.data th {\r\n  text-align: center;\r\n}\r\n\r\ntable.data td {\r\n  text-align: left;\r\n}\r\n\r\n.dialog_content_upper {\r\n  padding: 1rem;\r\n  display: grid;\r\n  grid-template-rows: 2rem auto;\r\n\r\n  &.no_padding {\r\n    padding: 0;\r\n  }\r\n\r\n  @media (max-width: 767px) {\r\n    padding: 1rem 1rem 1rem;\r\n  }\r\n\r\n  &:after {\r\n    clear: both;\r\n    content: '';\r\n    display: block;\r\n    height: 0;\r\n    visibility: hidden;\r\n  }\r\n\r\n  button {\r\n    margin-left: 1.5rem;\r\n  }\r\n}\r\n\r\n.container_importer {\r\n  display: grid;\r\n  width: 100%;\r\n  overflow: auto;\r\n}\r\n\r\n.aggregation-date-text {\r\n  font-size: smaller;\r\n}\r\n\r\n.dataset-error-link {\r\n  cursor: pointer;\r\n}\r\n\r\n.error-window-container {\r\n  position: fixed;\r\n  right: 100%;\r\n  top: 0%;\r\n  z-index: 99;\r\n}\r\n\r\nkendo-window {\r\n  border-radius: 4px !important;\r\n}\r\n\r\n:host ::ng-deep kendo-window-titlebar,\r\n:host ::ng-deep .k-dialog-titlebar,\r\n:host ::ng-deep .k-window-titlebar {\r\n  background-color: #51738b !important;\r\n  padding: 0.25rem 0.5rem !important;\r\n}\r\n\r\n.import_error_warning {\r\n  color: $notification;\r\n}\r\n\r\n.import_error_error {\r\n  color: $red;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
